// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9590949a","455":"335e5922","977":"cb6a4777"}[chunkId] + ".chunk.js";
};